import styled from 'styled-components';
export const TriggerButtons = styled.div`
width:fit-content;
height:48px;
display: inline-flex;
padding: 4px;
align-items: center;
gap: 8px;
flex-shrink: 0;
border-radius: 6px;
border: 1px solid var(--bold-filed, #E8EBF4);
background: var(--Blue-10, #F3F6F9);
width: 100%;
`
export const ButtonItem = styled.div`
display: inline-flex;
color:${(props) => props.clicked ? "var(--Blue-100, #2555EF)" : "var(--Dark-Blue-40, #99ABBE)"} ;
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--SwitchTabsButtonItemFont-family);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 32px; 
cursor: pointer;
padding: 4px 12px 4px 12px;
background-color:${(props) => props.clicked ? "var(--Blue-40, #C1CEF9)" : ""} ;
border-radius: 6px;
width: calc(100% / ${(props) => props.length || 3});
display: flex;
align-items: center;
justify-content: center;
`